import React from "react";
import { siteContent } from "../content";
const about = siteContent.about;

const About = () => {
  return (
    <div className="bg-primary-darker mt-44 overflow-hidden relative">
      <img
        src="/images/bg-about-b.jpeg"
        className=" absolute -top-1/2 left-0 right-0 bottom-0 w-full z-0 opacity-20"
        alt={about.title}
      />
      <div className="container py-48 z-20 relative">
        <h1 className="text-center font-bold text-4xl text-white">
          {about.title}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-justify text-white text-md mt-20">
          {about.content.map((text, i) => (
            <div key={i}>
              <img
                src={text.img}
                className="block w-20 mx-auto mb-10"
                alt={about.title}
              />
              {text.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
